/**
 * Created by Jason on 2017-3-14.
 */
let fullLoading = {
    init() {
        let _this = this;
        $(document.body).append(`<div id="full-loading">
            <div class="fa fa-pulse fa-spinner"></div>
            </div>`);
        _this.$box = $('#full-loading');
    },
    show() {
        this.$box.fadeIn();
    },
    hide() {
        this.$box.fadeOut();
    }
};
fullLoading.init();
module.exports = fullLoading;


// WEBPACK FOOTER //
// ./src/assets/lib/full-loading/full-loading.js